import axios from 'axios'
import Cookies from 'js-cookie'

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000
})

request.interceptors.request.use(config => {
  const token = Cookies.get('token') || ''
  if (!token) return Promise.reject(new Error('登录状态失效，请重新登录'))
  config.headers = config.headers || {}
  config.headers.Authorization = token.startsWith('Bearer ') ? token : `Bearer ${token}`
  return config
})

function getData (response, fallback) {
  const result = response.data || {}
  if (result.code !== 200) throw new Error(result.msg || result.message || fallback)
  return result.data
}

const Instruction = {
  list: (data) => request.post('instruction/list', data).then(res => getData(res, '说明书查询失败')),
  remove: (id) => request.delete('instruction/delete', { params: { id } }).then(res => getData(res, '说明书删除失败')),
  upload: (file) => {
    const formData = new FormData()
    formData.append('file', file)
    return request.post('common/upload', formData).then(res => {
      const data = getData(res, '说明书上传失败') || {}
      if (!data.key) throw new Error('上传响应缺少文件标识')
      return data
    })
  },
  save: (data) => request.post('instruction/save', data).then(res => getData(res, '说明书新增失败')),
  update: (data) => request.put('instruction/update', data).then(res => getData(res, '说明书更新失败'))
}

export default Instruction
